export default __webpack_public_path__ + "static/media/2011.626bb63c.png";